import { useRecordContext } from 'ra-core';
import { getAdminUserDisplayName } from './types';

/** The user's full name (or `User <id>`), e.g. inside a kit `ReferenceField` to `users` */
export const UserDisplayNameField = () => {
  const user = useRecordContext<{
    id: number | string;
    firstName?: string | null;
    lastName?: string | null;
  }>();

  if (!user) {
    return null;
  }

  return <span>{getAdminUserDisplayName(user)}</span>;
};
